import React, { useState } from 'react';
import { startAuthentication } from '@simplewebauthn/browser';
import { api, ApiError } from '../api';
import type { Me } from '../App';
import { useToast } from '../ui/Toast';

export function Login({ onLogin }: { onLogin: (me: Me) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/api/auth/login', { email, password });
      const me = await api.get<Me>('/api/auth/me');
      onLogin(me);
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : 'Login fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  const handlePasskey = async () => {
    if (!email) {
      toast.error('Bitte zuerst eine E-Mail eintragen.');
      return;
    }
    setBusy(true);
    try {
      const opts = await api.post<never>('/api/auth/passkey/login/options', { email });
      const response = await startAuthentication(opts);
      await api.post('/api/auth/passkey/login/verify', { email, response });
      const me = await api.get<Me>('/api/auth/me');
      onLogin(me);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'Passkey-Login fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg p-6">
      <div className="card w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-md bg-brand-gradient flex items-center justify-center text-white font-bold">FC</div>
          <div>
            <div className="text-h4">ForgeCalendar</div>
            <div className="text-meta uppercase tracking-[0.16em] text-ink-muted">bbfdesign Cockpit</div>
          </div>
        </div>
        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <div>
            <label className="label">E-Mail</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div>
            <label className="label">Passwort</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={busy}>
            Anmelden
          </button>
          <button type="button" className="btn btn-secondary" onClick={handlePasskey} disabled={busy}>
            Mit Passkey anmelden
          </button>
        </form>
      </div>
    </div>
  );
}
